import Schema from 'async-validator';

const pattern = {
  // 手机号
  mobile: /^1[23456789]\d{9}$/,
  // 车架号
  vinNo: /^[A-HJ-NPR-Z0-9]{17}$/,
  // 发动机号
  engineNo: /^[A-Z0-9]*$/,
  // 银行卡号
  bankCardNo: /^(\d{16,17}|\d{19})$/,
  // 车牌号
  // carNo: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}([A-HJ-NP-Z0-9]{2}|[A-HJ-NP-Z0-9挂学警港澳]{1})$/,
  carNo: /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[A-HJ-NP-Z])|([A-HJ-NP-Z]([A-HJ-NP-Z0-9])[0-9]{4})|([A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳领]{1})))$/
}

// 校验
const $validate = async (rules, form) => {
  const validator = new Schema(rules);
  let valiArray = [];
  try {
    await validator.validate(form)
  } catch ({ errors }) {
    valiArray = errors
  }
  return valiArray
}

export default {
  pattern,
  $validate,
}
